import React from 'react';
import styled from '@emotion/styled';

import DateWithClock from './DateWithClock';

function stripeSlug(slug, lang = 'EN') {
  const language = lang.includes('_')
    ? lang.replace('_', '-').toLocaleLowerCase()
    : lang.toLocaleLowerCase();

  if (slug.startsWith(`${language}-`)) {
    const splitRegex = new RegExp(`${language}-(.+)`);
    slug = slug.split(splitRegex)[1];
  }

  return slug;
}

const ArticleCard = ({
  node,
  className,
  isFooter = false,
  slugPrefix,
  language,
  featureImage,
}) => {
  const defaultAuthorImg =
    node?.author?.Avatar?.url ||
    'https://d2nb51khh83712.cloudfront.net/images/origin/3d_fish_b9782cfa14.png';

  const Image = featureImage
    ? featureImage.replace('origin', 'medium')
    : 'https://d2nb51khh83712.cloudfront.net/images/medium/upload_video_to_instagram_6281b0a3a5.jpg';

  return (
    <AnchorTag key={node.Title} className={className || 'md:w-1/2 p-4'}>
      <a href={`${slugPrefix}${stripeSlug(node.Slug, language)}/`}>
        <div className="rounded-lg overflow-hidden">
          <img
            className="image-thumbnail"
            loading="lazy"
            src={Image}
            alt={node?.FeatureImage?.alternativeText || 'Poster'}
          />
        </div>
        <h2 className="card-title mt-2 block text-black text-lg font-medium">
          {node.Title}
        </h2>
      </a>
      <div>
        <div className="text-gray-600 text-xs py-2 flex items-center">
          <img
            src={node.author?.img || defaultAuthorImg}
            width="30"
            height="30"
            alt="Avatar"
            className="author-thumbnail"
            loading="lazy"
          />
          <a className="text-black" href={`/blog/author/${node.author?.Slug}/`}>
            {node.author?.Name || 'Nick'} &nbsp;
          </a>
          <DateWithClock date={node.published_at} />
        </div>
        {isFooter && node.Excerpt && (
          <div className="card-excerpt content-post-grid">
            <p className="line-clamp-2">{node.Excerpt}</p>
          </div>
        )}
      </div>
    </AnchorTag>
  );
};

export default ArticleCard;

const AnchorTag = styled.div`
  .author-thumbnail {
    width: 25px;
    height: 25px;
    margin-right: 5px;
    border-radius: 50%;
  }
`;
